import PropTypes from 'prop-types'

const CustomDownloadName = ({ children, name }) => {
	return (
		<a href="#" className="sel__gallery__item--wrapper" download={name} onClick={(event) => event.preventDefault()}>
			{children}
		</a>
	)
}

CustomDownloadName.propTypes = {
	children: PropTypes.any.isRequired,
	name: PropTypes.string.isRequired,
}

export default CustomDownloadName
